(() => {
  window.swinger = window.swinger || {};
  window.swinger.errorLog = [];

  window.addEventListener('error', (e) => {
    window.swinger.errorLog.push(e);
  });
})();
